export class SlideshowSlideNav {
  position = 'no-position';
  onlyOnHover = '';
  largerStyle = '';
  margin = '';
  breakpoint = 'uk-visible@s';
  color = 'uk-dark';

  static normalize(styles: Partial<SlideshowSlideNav>): SlideshowSlideNav {
    const pureStyles = new SlideshowSlideNav();

    pureStyles.position = styles.position ?? pureStyles.position;
    pureStyles.onlyOnHover = styles.onlyOnHover ?? pureStyles.onlyOnHover;
    pureStyles.largerStyle = styles.largerStyle ?? pureStyles.largerStyle;
    pureStyles.margin = styles.margin ?? pureStyles.margin;
    pureStyles.breakpoint = styles.breakpoint ?? pureStyles.breakpoint;
    pureStyles.color = styles.color ?? pureStyles.color;

    return pureStyles;
  }
}
